import { render, staticRenderFns } from "./TheCookies.vue?vue&type=template&id=4429b50a&scoped=true"
import script from "./TheCookies.vue?vue&type=script&lang=ts&setup=true"
export * from "./TheCookies.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./TheCookies.vue?vue&type=style&index=0&id=4429b50a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4429b50a",
  null
  
)

export default component.exports